<div class="notification-panel-container">
  <header class="panel-header">
    <h3>Benachrichtigungen</h3>
    <mat-slide-toggle
      [checked]="showRead$ | async"
      (change)="toggleShowRead()">
      Gelesene anzeigen
    </mat-slide-toggle>
  </header>

  <mat-divider></mat-divider>

  @if (displayedNotifications$ | async; as notifications) {
    @if (notifications.length > 0) {
      <ul class="notification-list">
        @for (n of notifications; track n.id) {
          <li class="notification-item" (click)="onNotificationClick(n)" [class.unread]="!n.read">
            <mat-icon class="notification-icon">{{ n.type === 'REVIEW_APPROVED' ? 'check_circle' : 'info' }}</mat-icon>
            <div class="notification-content">
              <span class="notification-title">{{ n.message }}</span>
              <span class="notification-date">{{ n.createdAt | date:'dd.MM.yyyy HH:mm' }}</span>
            </div>
          </li>
        }
      </ul>
    } @else {
      <div class="empty-state">
        <mat-icon>notifications_off</mat-icon>
        <span>Du hast keine neuen Benachrichtigungen.</span>
      </div>
    }
  }
</div>
